"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "17",
  height: "21",
  viewBox: "0 0 17 21",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M3.66031 11.586C3.63016 11.487 3.63146 11.3811 3.66402 11.2829L6.11586 3.88911C6.22442 3.56173 6.62404 3.43999 6.89669 3.65126L13.0543 8.42243C13.136 8.4858 13.1962 8.57299 13.2263 8.67196L15.5315 16.2392C15.6119 16.5033 15.463 16.7827 15.1989 16.8632L6.58946 19.4858C6.3253 19.5663 6.04592 19.4173 5.96546 19.1532L3.66031 11.586Z"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "8.70865",
  cy: "10.0434",
  r: "1.5",
  transform: "rotate(-16.942 8.70865 10.0434)"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M8.88731 9.98832C11.7889 8.34756 13.5469 6.81797 13.1256 5.29398C12.5764 3.30694 9.35881 5.29399 9.35881 5.29399",
  "stroke-linecap": "round"
}));

exports["default"] = _default;